import React, { useContext, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Chart as ChartJS, LineElement, PointElement, Tooltip, Legend, RadialLinearScale, Filler, ArcElement } from 'chart.js'
import { PolarArea } from 'react-chartjs-2';
import { UserInfo } from "../Context/UserInfoContext";
import medhisCodes from "../../../JSONS/medhis_codes.json"
import HeartAgeCalc from '../CalculatorCodes/HeartAgeCode'
import DiabetesRiskCalc from '../CalculatorCodes/DiabetesRiskCode';
import SleepApneaCalc from '../CalculatorCodes/SleepApneaCode'
import MetabolicSyndromeCalc from '../CalculatorCodes/MetabolicCode'
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { Modal } from 'flowbite-react';
import restrictions from "../../../JSONS/calculator_res.json"

import DPCardioIcon from "../../Photos/DarkPurpleCardioHeartTransparent.png"
import DPAbsIcon from "../../Photos/DarkPurpleAbsPerimeterIcon.png"
import SBRealHeartIcon from "../../Photos/SkyBlueRealHeartIcon.svg"
import SBBedIcon from "../../Photos/SkyBlueBedIcon.png"
import SBCardiacProblemIcon from "../../Photos/SkyBlueCardiacProblemIcon.svg"
import SBIndicatorIcon from "../../Photos/SkyBlueIndicatorIcon.svg"
import SBWineIcon from "../../Photos/SkyBlueWineIcon.png"
import WSmokeIcon from "../../Photos/WhiteSmokeIcon.png"
import WAbsIcon from "../../Photos/WhiteAbsPerimeterIcon.png"
import WCardioIcon from "../../Photos/WhiteCardioHeartIcon.png"
import BHLow from "../../Photos/BigHeartLowRiskTp.png"
import BHMid from "../../Photos/BigHeartMidRiskTp.png"
import BHHigh from "../../Photos/BigHeartHighRiskTp.png"
import DiabetesImage from "../../Photos/DiabetesSurveyImage2.png"
import HabitsImage from "../../Photos/HabitsSurveyImage.png"
import SleepImage from "../../Photos/SleepApneaSurveyImage.png"
import MetabolicImage from "../../Photos/MetabolicSyndromeSurveyImage.png"
import MeterSimple from "../../Photos/RiskMeterHorizontalSimplified.png"
import MeterHabits from "../../Photos/RiskMeterHorizontalHabits.svg"
import FaceLowRisk from "../../Photos/RiskMeter_LowRiskFace.png"
import FaceMidRisk from "../../Photos/RiskMeter_MidRiskFace.png"
import FaceHighRisk from "../../Photos/RiskMeter_HighRiskFace.png"


ChartJS.register(
    LineElement, 
    PointElement, 
    Tooltip, 
    Legend, 
    RadialLinearScale,
    Filler,
    ArcElement
  )

const UserProfileHealthReport = () => {

    const Navigate = useNavigate();
    const MySwal = withReactContent(Swal)

    const {
        LoggedOut
    } = useContext(UserInfo);

    const [OneTime,setOneTime] = useState(true)
    const [IMC,setIMC] = useState(null)
    const [PMH,setPMH] = useState([])
    const [FMH,setFMH] = useState([])
    const [Cardios,setCardios] = useState([])
    const [FamCardio,setFamCardio] = useState(false)
    const [HighCardioRisk, setHighCardioRisk] = useState(false);
    const [DiabetesPresent, setDiabetesPresent] = useState(false);
    const [Heights,setHeights] = useState(null)
    const [Weights,setWeights] = useState(null)
    const [HeartAge,setHeartAge] = useState(false)
    const [HeartAge10,setHeartAge10] = useState(false)
    const [Habits,setHabits] = useState([])
    const [Diabetes,setDiabetes] = useState(false)
    const [Sleep,setSleep] = useState(false)
    const [Metabolic,setMetabolic] = useState(false)
    const [Parameters,setParameters] = useState(null)
    const [TaskStart,setTaskStart] = useState(false)
    const [TaskDone,setTaskDone] = useState(false)
    const [openModal, setOpenModal] = useState(false);

    const SurvCategories = ["Bienestar","Movimiento","Nutrición","Recuperación","Consumo"]

    const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
    const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
    const Name = decodedToken ? decodedToken.name : null
    const Rut = decodedToken ? decodedToken.rut : null
    const Gender = decodedToken ? parseInt(decodedToken.gender) : null;
    const DoB = decodedToken ? new Date(decodedToken.born) : null;
    const DoBMonth = DoB ? DoB.getMonth() + 1 : 0
    const DoBDay = DoB ? DoB.getDate() : 0
    const Email = decodedToken ? decodedToken.email : null
    const Phone = sessionStorage.getItem('Phone') ? sessionStorage.getItem('Phone') : decodedToken ? decodedToken.phone : null
    const Region = decodedToken ? decodedToken.region : null
    const Commune = decodedToken ? decodedToken.commune : null

    const opening = decodedToken && decodedToken.health_report === false && window.localStorage.getItem("HabitsCalculated") ? JSON.parse(window.localStorage.getItem("HabitsCalculated")) : decodedToken ? decodedToken.health_report : false
    const allowed = decodedToken && decodedToken.first_survey === false && window.localStorage.getItem("OpenAccess") ? JSON.parse(window.localStorage.getItem("OpenAccess")) : decodedToken ? decodedToken.first_survey : false

    function AgeCalc() {
        const currentDate = new Date();
        let dob = new Date(DoB)
    
        const age = currentDate.getFullYear() - dob.getFullYear();
        const currentMonth = currentDate.getMonth();
        const currentDay = currentDate.getDate();
    
        if (age > 15) {
          if (currentMonth > DoBMonth-1 || (currentMonth === DoBMonth-1 && currentDay >= DoBDay)) {
            return age;
          } else {
            return age-1;
          }
        } else if (age === 15) {
    
          if (currentMonth > DoBMonth-1 || (currentMonth === DoBMonth-1 && currentDay >= DoBDay)) {
            return age;
          }
        }
    
        return false;
    }
    const Age = AgeCalc()

    function getIMC(height, weight) {
        let imc = parseInt(weight)/(parseInt(height)/100)**2
        let cats = ["Bajo", "Saludable", "Sobrepeso", "Obesidad I", "Obesidad II", "Obesidad III"]
        let which = 0
        let ideal = [0,0]
        if(imc < 18.5) {
            which = 0
        } else if(imc < 25 & imc >= 18.5) {
            which = 1
        } else if(imc < 30 & imc >= 25) {
            which = 2
        } else if(imc < 35 & imc >= 30) {
            which = 3
        } else if(imc < 40 & imc >= 35) {
            which = 4
        } else {
            which = 5
        }
        ideal[0] = Math.round(((height/100)**2) * 18.5)
        ideal[1] = Math.round(((height/100)**2) * 25)
        return [imc, cats[which], which, ideal]
    }

    const requestGetPatient = useCallback(async() => {
        setTaskStart(true)

        let smoke = "NO"
        let cardio = false

        MySwal.fire({
            position: "center",
            html: 
            <div className="FullAlertWidth1">
                <div className="FullAlertUpTitle">Cargando información de informe...</div>
                <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
            </div>,
            color: "#340066",
            customClass: 'swal-wide',
            showConfirmButton: false,
            width: "100%",
        })

        let parameters = {
            rut: decodedToken.rut,
            for_build: true
        }
    
        let requestOptions = {
          method: 'POST',
          redirect: 'follow',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(parameters)
        };

        let parameters2 = {
            rut: decodedToken.rut,
            within: [1,2,3,18,51,52,53,54,56,57]
        }
    
        let requestOptions2 = {
            method: 'POST',
            redirect: 'follow',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(parameters2)
        };
    
        try{
            let resp = await fetch("https://ymc-doc-api.azurewebsites.net/getsurveyanswers", requestOptions)
            if (resp.status !== 200){
                MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error obteniendo los datos",
                    text: "Por favor inténtelo más tarde",
                    showConfirmButton: true
                });
                return false;
            }
            let data = await resp.json();
            
            if(data.habits) {
                setHabits([...data.habits])
            }

            if(data.pmh) { 
                setPMH([...data.pmh])
                if(data.pmh.includes("AP010")) {
                    smoke = "YES"
                }
                if(data.pmh.includes("AP035")) {
                    cardio = true
                    if(data.enf_card) {
                        setCardios([...data.enf_card])
                    }
                }
                if(data.pmh.some((med) => restrictions["cardio_risk"].exception_medhis.includes(med))) {
                    setHighCardioRisk(true)
                }
                if(data.pmh.some((med) => restrictions["diabetes"].exception_medhis.includes(med))) {
                    setDiabetesPresent(true)
                }
            }

            if(data.fmh) {
                setFMH([...data.fmh])
                if(data.fmh.includes("AF025") && data.fam_card) {
                    setFamCardio(data.fam_card)
                }
            }

            let hasParams = true
            let resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/getuserparams", requestOptions2)
            if (resp2.status !== 200){
                if(resp2.status !== 500) {
                MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error al subir los datos",
                    text: "Por favor inténtelo más tarde",
                    showConfirmButton: true
                });
                return false;
                } else {
                hasParams = false
                }
            }
            let data2 = await resp2.json();
            
            if(hasParams) {
                if(data2.params["51"]) {
                    setWeights(data2.params["51"])
                }
                if(data2.params["52"]) {
                    setHeights(data2.params["52"])
                }
                if(data2.params["51"] && data2.params["52"]) {
                    let imc = getIMC(data2.params["52"][1],data2.params["51"][1])
                    setIMC(imc)
                    if(data.diab && data2.params["56"]) {
                        let gender = Gender === 1 ? "M" : "F"
                        let tmp2 = await DiabetesRiskCalc(gender,
                            Age,
                            imc,
                            data2.params["56"],
                            data.diab.YN[0],
                            data.diab.YN[1],
                            data.diab.YN[2],
                            data.diab.YN[3],
                            data.diab.YN[4],
                            data.diab.YN[5])
                        let diabs = {}
                        diabs["points"] = tmp2
                        if(tmp2 < 7) {
                            diabs["riskCat"] = "Muy Bajo"
                            diabs["risk"] = 0
                        } else if(tmp2 < 12) {
                            diabs["riskCat"] = "Bajo"
                            diabs["risk"] = 1
                        } else if(tmp2 < 15) {
                            diabs["riskCat"] = "Moderado"
                            diabs["risk"] = 2
                        } else if(tmp2 < 20) {
                            diabs["riskCat"] = "Alto"
                            diabs["risk"] = 3
                        } else {
                            diabs["riskCat"] = "Muy Alto"
                            diabs["risk"] = 4
                        }
                        setDiabetes(diabs)
                    }

                    if(data.sleep && data2.params["53"] && data2.params["57"]) {
                        let gender = Gender === 1 ? "M" : "F"
                        let tmp3 = await SleepApneaCalc(gender,
                            Age,
                            imc,
                            data2.params["53"],
                            data2.params["57"],
                            data.sleep.YN)
                        setSleep(tmp3)
                    }
                }
                if(data2.params["53"] && data2.params["2"]) {
                    let gender = Gender === 1 ? "M" : "F"
                    if(cardio) {
                        setHeartAge(-1)
                    } else {
                        let tmp = await HeartAgeCalc(gender, Age, smoke, data2.params["53"][1], data2.params["2"][1])
                        let tmp2 = await HeartAgeCalc(gender, Age+10, smoke, data2.params["53"][1], data2.params["2"][1])
                        setHeartAge(tmp)
                        setHeartAge10(tmp2)
                    }
                }
                if(data2.params["1"] && data2.params["3"] && data2.params["18"] && data2.params["53"] && data2.params["54"] && data2.params["56"]) {
                    let gender = Gender === 1 ? "M" : "F"
                    let tmp = await MetabolicSyndromeCalc(gender,data2.params["56"],data2.params["1"],data2.params["3"],data2.params["53"],data2.params["54"],data2.params["18"])
                    setMetabolic(tmp)
                } 
                setParameters(data2.params)
            }
    
            MySwal.close();
            setTaskStart(false);
            setTaskDone(true);
        }
        catch(error){
            MySwal.close();
            alert("Ocurrió un error procesando la búsqueda");
            return false;
        }
    },[Age,Gender,MySwal,decodedToken]);

    useEffect(() => {
        if(OneTime) {
            if(!sessionStorage.getItem('token')) {
                Navigate("/")
            }
            if(decodedToken && allowed && opening) {
                requestGetPatient()
            }
            setOneTime(false)
        }

        if(!sessionStorage.getItem('token')) {
            Navigate("/")
        }

        if(!opening) {
            window.scrollTo(0, 0);
            Navigate("/perfil-de-usuario")
        }

        if(LoggedOut) {
            MySwal.close();
        }
    }, [OneTime, opening, LoggedOut, decodedToken, requestGetPatient, Navigate, MySwal, allowed]);

    const GraphBG = Habits && Habits.length !== 0 ? Habits.map((a) => a < 4 ? "rgba(255, 0, 0, .3)" : a < 8 ? "rgba(255, 205, 41, .3)" : "rgba(139, 197, 63, .3)") : "rgba(139, 197, 63, .3)"
    const GraphBGTicks = Habits && Habits.length !== 0 ? Habits.map((a) => a < 4 ? "rgba(255, 0, 0, .6)" : a < 8 ? "rgba(255, 205, 41, .6)" : "rgba(139, 197, 63, .6)") : "rgba(139, 197, 63, .6)"

    const GraphData= {
        labels: ['Bienestar','Movimiento','Nutrición','Recuperación','Consumo'],
        datasets: [{
            label: " Puntaje",
            circular: false,
            data: Habits,
            fill: true,
            borderColor: '#CCCCFF',
            pointBackgroundColor: '#6633FF',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(54, 162, 235)',
            backgroundColor: GraphBG,
            borderWidth: 1
        }],
    }
  
    const GraphOptions = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
            legend: {
            display: false,
            },
        },
        scales: {
            r: {
                angleLines: {
                    display: true
                },
                ticks: {
                    display: false
                },
                pointLabels: {
                display: true,
                centerPointLabels: true,
                font: {
                    size: 10,
                    colors: GraphBGTicks
                },
                color: "#6633FF",
                padding: -25
                },
                grid: {
                circular: false
                }
            },
        },
        scale: {
            r: {
            min: 0, // MIN
            max: 10, // MAX
            beginAtZero: true,
            display: false,
            angleLines: {
                display: true,
                color: 'red'
            }
    
            },
            ticks: {
                beginAtZero: true,
                max: 10,
                min: 0,
                stepSize: 1
            },
            pointLabels: {
            display: true,
            font: {size: 20}
            },
            angleLines: {
            color: 'red'
            }
        },
    }

    function toggleSummary(num) {
        let tmp = document.getElementById("Hide"+num)
        let tmp2 = document.getElementById("Arrow"+num)
        if(!tmp.className.includes("UserProfileInnerDivCalculatorWhiteBlockSummaryHidden")) {
            tmp.className += " UserProfileInnerDivCalculatorWhiteBlockSummaryHidden"
            tmp2.style.transform = 'rotate(0deg)'
        } else {
            tmp.className = tmp.className.replace(" UserProfileInnerDivCalculatorWhiteBlockSummaryHidden", "")
            tmp2.style.transform = 'rotate(180deg)'
        }
    }

    function PDFstuff() {
        Promise.all([
            html2canvas(document.getElementById('myPage'), { quality: 0.9 }),
            html2canvas(document.getElementById('myPage2'), { quality: 0.9 }),
            html2canvas(document.getElementById('myPage3'), { quality: 0.9 })
        ])
            .then(function ([dataUrl,  dataUrl2, dataUrl3]) {
                let img = dataUrl;
                let pdf = new jsPDF({
                      orientation: 'l', // landscape
                      unit: 'pt', // points, pixels won't work properly
                      format: [document.getElementById('myPage').offsetWidth, document.getElementById('myPage').offsetHeight] // set needed dimensions for any element
                });
                pdf.addImage(img, 'JPEG', 0, 0, document.getElementById('myPage').offsetWidth, document.getElementById('myPage').offsetHeight);
                
                let img2 = dataUrl2;
                pdf.addPage(
                    [document.getElementById('myPage2').offsetWidth, document.getElementById('myPage2').offsetHeight],
                    'l'
                );
                pdf.addImage(img2, 'JPEG', 0, 0, document.getElementById('myPage2').offsetWidth, document.getElementById('myPage2').offsetHeight);

                if(Diabetes || Sleep || Metabolic) {
                    let img3 = dataUrl3;
                    pdf.addPage(
                        [document.getElementById('myPage3').offsetWidth, document.getElementById('myPage3').offsetHeight],
                        'l'
                    );
                    pdf.addImage(img3, 'JPEG', 0, 0, document.getElementById('myPage3').offsetWidth, document.getElementById('myPage3').offsetHeight);
                }

                pdf.save("Informe de salud "+decodedToken.name+".pdf"); 
            });
    }

    function Report({ pdf }) {
        return (
        <div className={pdf ? 'UserProfileInnerDiv UserProfileHealthReportInnerDivPDF' : 'UserProfileInnerDiv UserProfileHealthReportInnerDiv'}>
            <div className={pdf ? 'UserProfileHealthReportUpperBlockPDF' : 'UserProfileHealthReportUpperBlock'} id={pdf ? "myPage" : null}>
                <div className='UserProfileHealthReportWhiteBlock UserProfileHealthReportUpperBlockLeftSide'>
                    <h3 className='UserProfilePageTitle'>{Name ? Name : "-"}</h3>
                    <div className='UserProfileHealthReportUpperBlockLeftSideTexts'>
                        <div className='UserProfileHealthReportUpperBlockLeftSideTextsSide'>
                            <div className=''>
                                <div className="UserProfilePageBlueText">Correo electronico:</div>
                                <div className="UserProfilePageBlueText">{Email ? Email : "-"}</div>
                            </div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight2'>Rut:</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{Rut ? Rut : "-"}</div>
                            </div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight2'>Fecha de Nacimiento:</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{DoB ? DoB.toLocaleDateString('fr-ca') : "-"}</div>
                            </div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight2'>Sexo de Nacimiento:</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{Gender === 1 ? "Hombre" : "Mujer"}</div>
                            </div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight2'>Edad:</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{Age ? Age : "-"}</div>
                            </div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight2'>Teléfono:</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{Phone ? Phone : "-"}</div>
                            </div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight2'>Región:</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{Region ? Region : "-"}</div>
                            </div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight2'>Comuna:</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{Commune ? Commune : "-"}</div>
                            </div>
                        </div>
                        <div className='UserProfileHealthReportUpperBlockLeftSideTextsSide2'>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexLeft'>Diagnósticos previos</div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhisBlocks'>
                                {PMH.length !== 0 ? PMH.filter((e) => e !== "AP035").map((medhis) => (
                                    <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhis' key={medhis}>{medhisCodes[medhis]}</div>
                                ))
                                : <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhis'>-</div> 
                                }
                            </div> 
                            {PMH.includes("AP035") && Cardios.length !== 0 ?
                            <>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexLeft'>Enfermedades cardiovasculares</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhisBlocks'>
                                    {Cardios.map((medhis) => (
                                        <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhis' key={medhis}>{medhisCodes[medhis]}</div>
                                    ))}
                                </div> 
                            </>
                            : null}
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexLeft'>Antecedentes familiares</div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhisBlocks'>
                                {FMH.length !== 0 ? FMH.map((medhis) => (
                                    <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhis' key={medhis}>{medhisCodes[medhis]}</div>
                                ))
                                : <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhis'>-</div> 
                                }
                            </div> 
                            {FamCardio && FamCardio !== "NA" ?
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexLeft'>Enfermedad cardiovascular en padres: {FamCardio}</div>
                            : null}
                        </div>
                    </div>
                    {/*
                    <img alt="" className='UserProfileHealthReportUpperBlockLeftSideBackgroundImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage3Vect.svg"/>
                    <div className='UserProfileHealthReportUpperBlockLeftSideTexts'>
                        <h2 className='UserProfileHealthReportUpperBlockLeftSideTitle'>Analiza tus resultados para intervenir en tu gestión de riesgos</h2>
                        <div className='UserProfileHealthReportUpperBlockLeftSideSubtitle'>Los resultados indican un riesgo elevado basado en tus mediciones clínicas y hábitos actuales. Es probable que ya existan problemas de salud o que estén en desarrollo, como hipertensión, prediabetes o desequilibrios metabólicos.</div>
                        {pdf ? null :
                        <div className='UserProfileHealthReportUpperBlockLeftSideButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/antecedentes-medicos")}}>
                            <h4 className='UserProfileHealthReportUpperBlockLeftSideButtonText1'>Actualizar Indicadores</h4>
                            <div className='UserProfileHealthReportUpperBlockLeftSideButtonText2'>ver &gt;</div>
                        </div>
                        }
                    </div>
                    */}
                </div>
                <div className='UserProfileHealthReportWhiteBlock2 UserProfileHealthReportUpperBlockRightSide'>
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex'>
                        <img alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBCardiacProblemIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Factores de riesgo detectados</div>
                    </div>
                    <div className='UserProfileHealthReportHideableBlock'>
                        {Parameters && Parameters["53"] && (Parameters["53"][1] < 90 || Parameters["53"][1] > 120) ? 
                        <div className='UserProfileHealthReportUpperBlockRightSideIndicatorFlex'>
                            <div className='UserProfileHealthReportUpperBlockRightSideIndicatorLeft' style={Parameters["53"][1] >= 80 && Parameters["53"][1] <= 130 ? {backgroundColor:"#FFCD29"} : {backgroundColor:"#FF4F53"}}>
                                <img alt="" className='UserProfileHealthReportUpperBlockRightSideIndicatorLefticon' src={Parameters["53"][1] < 80 || Parameters["53"][1] > 130 ? WCardioIcon : DPCardioIcon }/>
                            </div>
                            <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRight'>
                                <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRightTitle'>{Parameters["53"][1] > 120 && Parameters["53"][1] <= 130 ? "Tu presión arterial está elevada" : Parameters["53"][1] > 130 ? "Tu presión arterial está muy elevada" : Parameters["53"][1] >= 80 ? "Tu presión arterial está baja" : "Tu presión arterial está muy baja"}</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRightText'>{Parameters["53"][1]+"mmHg"}</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRightInnerFlex'>
                                    <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRightText2'>Rango recomendado</div>
                                    <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRightText2' style={{textAlign:"right"}}>90 a 120 mmHg</div>
                                </div>
                            </div>
                        </div>
                        : 
                        null }

                        {IMC && IMC[2] !== 1 ?
                        <div className='UserProfileHealthReportUpperBlockRightSideIndicatorFlex'>
                            <div className='UserProfileHealthReportUpperBlockRightSideIndicatorLeft' style={IMC[2] === 0 || IMC[2] === 2 ? {backgroundColor:"#FFCD29"} : {backgroundColor:"#FF4F53", color:"white"}}>
                                <img alt="" className='UserProfileHealthReportUpperBlockRightSideIndicatorLefticon' src={IMC[2] === 3 ? WAbsIcon : DPAbsIcon}/>
                            </div>
                            <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRight'>
                                <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRightTitle'>Estado nutricional: {IMC[2] === 0 ? "Bajo el peso saludable" : IMC[2] === 2 ? "Sobrepeso" : IMC[2] === 3 ? "Obesidad I" : IMC[2] === 3 ? "Obesidad II" : "Obesidad III"}</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRightText'>{Weights[1]} kg</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRightInnerFlex'>
                                    <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRightText2'>Rango recomendado</div>
                                    <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRightText2' style={{textAlign:"right"}}>{IMC[3][0]} a {IMC[3][1]} kg</div>
                                </div>
                            </div>
                        </div>
                        : null }

                        {PMH.length !== 0 && PMH.includes("AP010") ?
                        <div className='UserProfileHealthReportUpperBlockRightSideIndicatorFlex'>
                            <div className='UserProfileHealthReportUpperBlockRightSideIndicatorLeft' style={{backgroundColor:"#FF4F53"}}>
                                <img alt="" className='UserProfileHealthReportUpperBlockRightSideIndicatorLefticon' src={WSmokeIcon} />
                            </div>
                            <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRight' style={{marginBlock:"auto"}}>
                                <div className='UserProfileHealthReportUpperBlockRightSideIndicatorRightTitle'>Fumador</div>
                            </div>
                        </div>
                        : null}

                        <div className='UserProfileHealthReportUpperBlockRightSideSectionBottomText'>¡Por suerte, estos factores son modificables! 
                            <br/>Te ayudaremos a corregirlos.</div>
                    </div>
                </div>
            </div>

            <div className={pdf ? 'UserProfileHealthReportUpperBlockPDF' : 'UserProfileHealthReportUpperBlock'} id={pdf ? "myPage2" : null}>
                <div className={pdf ? 'UserProfileHealthReportWhiteBlock2 UserProfileHealthReportUpperBlockLeftSidePDF' : 'UserProfileHealthReportWhiteBlock2 UserProfileHealthReportUpperBlockLeftSide'}>
                    {pdf ?
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex'>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBWineIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Evaluación tus hábitos saludables</div>
                    </div>
                    :
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex' style={{cursor:"pointer"}} onClick={() => toggleSummary(1)}>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBWineIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Evaluación tus hábitos saludables</div>
                        <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonIconFlex'>
                            <img alt="Down Arrow" id="Arrow1" className='UserProfileInnerDivCalculatorWhiteBlockDoneBlockIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleDownArrowIcon.png" />
                        </div>
                    </div>
                    }
                    <div className={pdf ? 'UserProfileHealthReportHideableBlock' : 'UserProfileHealthReportHideableBlock UserProfileInnerDivCalculatorWhiteBlockSummaryHidden'} id="Hide1">
                        <div className='UserProfileHealthReportHabitsFlex'>
                            <div className='UserProfileHealthReportHabitsLeft'>
                                {(Habits.reduce((partialSum, a) => partialSum + a, 0)*2) > 75 ?
                                <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{backgroundColor:"#8BC53F"}}>
                                    <h5 className='UserProfileHealthReportHabitsLeftUpBlockText'>{Habits.reduce((partialSum, a) => partialSum + a, 0)} de 50 puntos</h5>
                                </div>
                                : (Habits.reduce((partialSum, a) => partialSum + a, 0)*2) > 50 ?
                                <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{backgroundColor:"#FFCD29"}}>
                                    <h5 className='UserProfileHealthReportHabitsLeftUpBlockText'>{Habits.reduce((partialSum, a) => partialSum + a, 0)} de 50 puntos</h5>
                                </div>
                                :
                                <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{backgroundColor:"#FF4F53"}}>
                                    <h5 className='UserProfileHealthReportHabitsLeftUpBlockText' style={{color: "white"}}>{Habits.reduce((partialSum, a) => partialSum + a, 0)} de 50 puntos</h5>
                                </div>
                                }
                                <div className='UserProfileHealthReportHabitsLeftFlex'>
                                    <div className='UserProfileHealthReportHabitsLeftSideBlock' style={{backgroundColor: (Habits.reduce((partialSum, a) => partialSum + a, 0)*2) > 75 ? "rgba(139, 197, 63, 0.47)" : (Habits.reduce((partialSum, a) => partialSum + a, 0)*2) > 50 ? "rgba(255, 205, 41, 0.50)" : "rgba(255, 79, 83, 0.47)"}}>
                                        <img alt="" className='UserProfileHealthReportHabitsLeftSideBlockImage' src={HabitsImage} />
                                    </div>
                                    <div className='UserProfileHealthReportHabitsLeftSideBlock' style={{backgroundColor: (Habits.reduce((partialSum, a) => partialSum + a, 0)*2) > 75 ? "#8BC53F" : (Habits.reduce((partialSum, a) => partialSum + a, 0)*2) > 50 ? "#FFCD29" : "#FF4F53"}}>
                                        {[...Array(Habits.length).keys()].map((ind) => (
                                            <div key={SurvCategories[ind]} className='UserProfileHealthReportHabitsLeftSideInnerBlock' style={{backgroundColor: Habits[ind] > 7 ? "#8BC53F" : Habits[ind] > 4 ? "#FFCD29" : "#FF4F53", color: Habits[ind] <= 4 ? "white" : null}} >
                                                {SurvCategories[ind]} {Habits[ind]*10}%</div>
                                        ))}
                                    </div>
                                </div>
                                <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url("+MeterHabits+")",backgroundPosition: 'center',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                                    <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace HeartAgeCalculatorLeftSideResultHeartBlockMeterFaceCorrection"  src={Habits.reduce((partialSum, a) => partialSum + a, 0)*2 > 75 ? FaceLowRisk : Habits.reduce((partialSum, a) => partialSum + a, 0)*2 > 50 ? FaceMidRisk : FaceHighRisk} style={ Habits.reduce((partialSum, a) => partialSum + a, 0)*2 > 75 ? { left: Habits.reduce((partialSum, a) => partialSum + a, 0)*2-12.5 + "%" } : Habits.reduce((partialSum, a) => partialSum + a, 0)*2 > 50 ? { left: Habits.reduce((partialSum, a) => partialSum + a, 0)*2-12.5 + "%" } : { left: Habits.reduce((partialSum, a) => partialSum + a, 0)*2-12.5 + "%"}} />
                                </div>
                                <div className='UserProfileHealthReportGeneralText' style={{color:"#330066"}}>Tus hábitos actuales pueden estar afectando seriamente tu salud y bienestar. Es importante tomar acción inmediata para evitar problemas mayores. Pequeños cambios hoy pueden prevenir complicaciones mañana.</div>
                                <div className='UserProfileHealthReportUnderBlockBigFlexRightSideUpperBlockRadarGraphDiv' style={{marginInline:"auto"}}>
                                    <PolarArea data={GraphData} options={GraphOptions}  className='UserProfileHealthReportUnderBlockBigFlexRightSideUpperBlockRadarGraph'></PolarArea>
                                </div>
                            </div>
                            <div className='UserProfileHealthReportHabitsRight'>
                                <div className='UserWelcomeResultsCategories' style={{marginBlockEnd:"15px"}}>
                                    <h4 className='UserWelcomeBlockResultsCategoriesTitle'>Categorías de Evaluación y su Relevancia</h4>
                                    <div className='UserWelcomeBlockResultsCategoriesSubtitle'>No es necesario transformar todos tus hábitos de inmediato. Enfócate en pequeños cambios diarios y sigue nuestras recomendaciones específicas para cada categoría. Recuerda que el cambio gradual y sostenido es la clave para alcanzar un bienestar integral.</div>
                                    <div className='UserWelcomeBlockResultsCategoriesTitle2'>Movimiento {Habits[0]}/10</div>
                                    <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Mantenerte físicamente activo no solo mejora tu salud cardiovascular, sino que también reduce el riesgo de enfermedades crónicas, fortalece los músculos y mejora tu estado de ánimo.</div>
                                    <div className='UserWelcomeBlockResultsCategoriesTitle2'>Recuperación {Habits[1]}/10</div>
                                    <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Dormir y manejar el estrés son fundamentales para la regeneración celular, la salud mental y la capacidad de tomar decisiones.</div>
                                    <div className='UserWelcomeBlockResultsCategoriesTitle2'>Consumo {Habits[2]}/10</div>
                                    <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Lo que bebes o fumas impacta directamente en tus niveles de energía, hidratación y salud metabólica.</div>
                                    <div className='UserWelcomeBlockResultsCategoriesTitle2'>Nutrición {Habits[3]}/10</div>
                                    <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Una alimentación equilibrada es la base para mantener un cuerpo fuerte, un sistema inmunológico resistente y una mente clara.</div>
                                    <div className='UserWelcomeBlockResultsCategoriesTitle2'>Bienestar {Habits[4]}/10</div>
                                    <div className='UserWelcomeBlockResultsCategoriesSubtitle'>El bienestar emocional, las relaciones sociales y el propósito personal influyen directamente en tu calidad de vida.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {HighCardioRisk ?
                <div className={pdf ? 'UserProfileHealthReportWhiteBlock2 UserProfileHealthReportUpperBlockRightSidePDF': 'UserProfileHealthReportWhiteBlock2 UserProfileHealthReportUpperBlockRightSide'}>
                    {pdf ? 
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex'>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBRealHeartIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Riesgo Cardiovascular</div>
                    </div>
                    :
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex' style={{cursor:"pointer"}} onClick={() => toggleSummary(2)}>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBRealHeartIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Riesgo Cardiovascular</div>
                        <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonIconFlex'>
                            <img alt="Down Arrow" id="Arrow2" className='UserProfileInnerDivCalculatorWhiteBlockDoneBlockIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleDownArrowIcon.png" />
                        </div>
                    </div>
                    }
                    <div className={pdf ? 'UserProfileHealthReportHideableBlock' : 'UserProfileHealthReportHideableBlock UserProfileInnerDivCalculatorWhiteBlockSummaryHidden'} id="Hide2">
                        <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{ backgroundColor: "rgba(255, 79, 83, 1)", color: "white"}}>
                            <h5 className='UserProfileHealthReportHabitsLeftUpBlockText'>Riesgo cardiovascular a 10 años</h5>
                        </div>
                        <div className='UserProfileHealthReportHabitsLeftFlex'>
                            <div className='UserProfileHealthReportHabitsLeftSideBlock' style={{ backgroundColor: "rgba(255, 79, 83, .47)", color: "white"}}>
                                <img alt="" className='UserProfileHealthReportHabitsLeftSideBlockImage' src={BHHigh} />
                            </div>
                            <div className='UserProfileHealthReportHabitsLeftSideBlock2' style={{ backgroundColor: "rgba(255, 79, 83, 1)", color: "white"}}>
                                <h4 className="UserProfileHealthReportHabitsLeftSideBlockText">Riesgo Alto</h4>
                                <div className="UserProfileHealthReportGeneralText">De contraer una enfermedad cardiovascular en los próximos 10 años</div>
                            </div>
                        </div>
                        <div className="UserProfileHealthReportGeneralText" style={{marginBlockEnd:"10px", color:"#330066", textAlign:"center"}}>Según clasificación MINSAL</div>
                        <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url("+MeterSimple+")",backgroundPosition: 'left',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                            <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src={FaceHighRisk} style={{ right: "-5px" }} />
                        </div>
                        <div className="UserProfileHealthReportGeneralText" style={{marginBlockStart:"10px", color:"#330066"}}>Hay ciertas condiciones clínicas que, por sí solas, ya te ponen en un alto riesgo cardiovascular. La más conocida es haber tenido un infarto o un accidente cerebrovascular. Sin embargo, también existen otras condiciones que, aunque no sean tan graves como un evento previo, igualmente se asocian a un riesgo cardiovascular elevado. En tu caso, y según los antecedentes que presentas, te clasificamos directamente como una persona de alto riesgo, de acuerdo con los criterios del Ministerio de Salud de Chile, por lo que también calificas para ingresar al Programa de Salud Cardiovascular.</div>
                    </div>
                </div>
                : restrictions["cardio_risk"].min_age <= Age && restrictions["cardio_risk"].max_age >= Age && HeartAge && !HighCardioRisk ?
                <div className='UserProfileHealthReportWhiteBlock2 UserProfileHealthReportUpperBlockRightSide'>
                    {pdf ? 
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex'>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBRealHeartIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Riesgo Cardiovascular</div>
                    </div>
                    : 
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex' style={{cursor:"pointer"}} onClick={() => toggleSummary(2)}>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBRealHeartIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Riesgo Cardiovascular</div>
                        <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonIconFlex'>
                            <img alt="Down Arrow" id="Arrow2" className='UserProfileInnerDivCalculatorWhiteBlockDoneBlockIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleDownArrowIcon.png" />
                        </div>
                    </div>
                    }
                    {Age >= restrictions["cardio_risk"].exception_min_age ?
                    <div className={pdf ? 'UserProfileHealthReportHideableBlock' : 'UserProfileHealthReportHideableBlock UserProfileInnerDivCalculatorWhiteBlockSummaryHidden'} id="Hide2">
                        <h4 className='UserWelcomeBlockResultsCategoriesTitle'>Edad de tu corazón</h4>
                        <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{ backgroundColor: HeartAge.cardioRisk === 0 ? "rgba(139, 197, 63, 1)" : HeartAge.cardioRisk <= 3 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: HeartAge.cardioRisk >= 4 ? "white": ""}}>
                            <h5 className='UserProfileHealthReportHabitsLeftUpBlockText'>¡Tu corazón tiene {HeartAge.heartAge-Age} años más que tu!</h5>
                        </div>
                        <div className='UserProfileHealthReportHabitsLeftFlex'>
                            <div className='UserProfileHealthReportHabitsLeftSideBlock' style={{ backgroundColor: HeartAge.cardioRisk === 0 ? "rgba(139, 197, 63, .47)" : HeartAge.cardioRisk <= 3 ? "rgba(255, 205, 41, .5)" : "rgba(255, 79, 83, .47)", color: HeartAge.cardioRisk >= 4 ? "white": ""}}>
                                <img alt="" className='UserProfileHealthReportHabitsLeftSideBlockImage' src={HeartAge.cardioRisk === 0 ? BHLow : HeartAge.cardioRisk <= 3 ? BHMid : BHHigh} />
                                <h3 className='UserProfileHealthReportHeartAgeNumber'>{HeartAge.heartAge}</h3>
                            </div>
                            <div className='UserProfileHealthReportHabitsLeftSideBlock2' style={{ backgroundColor: HeartAge.cardioRisk === 0 ? "rgba(139, 197, 63, 1)" : HeartAge.cardioRisk <= 3 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: HeartAge.cardioRisk >= 4 ? "white": ""}}>
                                <div className="UserProfileHealthReportGeneralText">Esto significa que hoy tienes la misma probabilidad de morir por un  episodio cardiovascular que una persona de {HeartAge.heartAge} años sana.</div>
                            </div>
                        </div>
                        <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{ backgroundColor: HeartAge.cardioRisk === 0 ? "rgba(139, 197, 63, 1)" : HeartAge.cardioRisk <= 3 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: HeartAge.cardioRisk >= 4 ? "white": ""}}>
                            <h5 className='UserProfileHealthReportHabitsLeftUpBlockText'>Riesgo Cardiovascular Actual {HeartAge.cardioRiskCat}</h5>
                        </div>
                        <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url("+MeterSimple+")",backgroundPosition: 'left',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                            <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src={HeartAge.cardioRisk === 0 ? FaceLowRisk : HeartAge.cardioRisk <= 3 ? FaceMidRisk : FaceHighRisk} style={ HeartAge.cardioRisk === 0 ? { left: "0%" } : HeartAge.cardioRisk <= 3 ? { left: "-3px", right: "0", margin: "0 auto" } : { right: "-5px" } } />
                        </div>
                        <h4 className='UserWelcomeBlockResultsCategoriesTitle' style={{marginBlockStart:"10px"}}>Manteniendo tu estilo de vida ¿Qué pasaría con tu riesgo cardiovascular en 10 años?</h4>
                        <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{ backgroundColor: HeartAge10.cardioRisk === 0 ? "rgba(139, 197, 63, 1)" : HeartAge10.cardioRisk <= 3 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: HeartAge10.cardioRisk >= 4 ? "white": ""}}>
                            <h5 className='UserProfileHealthReportHabitsLeftUpBlockText'>Riesgo Cardiovascular {HeartAge10.cardioRiskCat}</h5>
                        </div>
                        <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url("+MeterSimple+")",backgroundPosition: 'left',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                            <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src={HeartAge10.cardioRisk === 0 ? FaceLowRisk : HeartAge10.cardioRisk <= 3 ? FaceMidRisk : FaceHighRisk} style={ HeartAge10.cardioRisk === 0 ? { left: "0%" } : HeartAge10.cardioRisk <= 3 ? { left: "-3px", right: "0", margin: "0 auto" } : { right: "-5px" } } />
                        </div>
                        <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{ backgroundColor: HeartAge10.cardioRisk === 0 ? "rgba(139, 197, 63, 1)" : HeartAge10.cardioRisk <= 3 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: HeartAge10.cardioRisk >= 4 ? "white": ""}}>
                            <div className='UserProfileHealthReportHeartRiskLowerText'>Cuando cumplas {Age+10} años tu corazón tendrá <span style={{fontWeight:"700"}}>{HeartAge10.heartAge-(Age+10)} años de envejecimiento prematuro</span>, teniendo la misma probabilidad de morir por un episodio cardiovascular que una persona sana de {HeartAge10.heartAge} años. </div>
                        </div>
                    </div>
                    : 
                    <div className={pdf ? 'UserProfileHealthReportHideableBlock' : 'UserProfileHealthReportHideableBlock UserProfileInnerDivCalculatorWhiteBlockSummaryHidden'} id="Hide2">
                        <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{ backgroundColor: HeartAge.cardioRisk === 0 ? "rgba(139, 197, 63, 1)" : HeartAge.cardioRisk <= 3 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: HeartAge.cardioRisk >= 4 ? "white": ""}}>
                            <h5 className='UserProfileHealthReportHabitsLeftUpBlockText'>Riesgo cardiovascular a 10 años</h5>
                        </div>
                        <div className='UserProfileHealthReportHabitsLeftFlex'>
                            <div className='UserProfileHealthReportHabitsLeftSideBlock' style={{ backgroundColor: HeartAge.cardioRisk === 0 ? "rgba(139, 197, 63, .47)" : HeartAge.cardioRisk <= 3 ? "rgba(255, 205, 41, .5)" : "rgba(255, 79, 83, .47)", color: HeartAge.cardioRisk >= 4 ? "white": ""}}>
                                <img alt="" className='UserProfileHealthReportHabitsLeftSideBlockImage' src={HeartAge.cardioRisk === 0 ? BHLow : HeartAge.cardioRisk <= 3 ? BHMid : BHHigh} />
                            </div>
                            <div className='UserProfileHealthReportHabitsLeftSideBlock2' style={{ backgroundColor: HeartAge.cardioRisk === 0 ? "rgba(139, 197, 63, 1)" : HeartAge.cardioRisk <= 3 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: HeartAge.cardioRisk >= 4 ? "white": ""}}>
                                <h4 className="UserProfileHealthReportHabitsLeftSideBlockText">Riesgo {HeartAge.cardioRiskCat}</h4>
                                <div className="UserProfileHealthReportGeneralText">De contraer una enfermedad cardiovascular en los próximos 10 años</div>
                            </div>
                        </div>
                        <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url("+MeterSimple+")",backgroundPosition: 'left',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                            <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src={HeartAge.cardioRisk === 0 ? FaceLowRisk : HeartAge.cardioRisk <= 3 ? FaceMidRisk : FaceHighRisk} style={ HeartAge.cardioRisk === 0 ? { left: "0%" } : HeartAge.cardioRisk <= 3 ? { left: "-3px", right: "0", margin: "0 auto" } : { right: "-5px" } } />
                        </div>
                    </div>
                }
                </div>
                : null}
            </div>

            <div className={pdf ? 'UserProfileHealthReportUpperBlockPDF' : 'UserProfileHealthReportUpperBlock'} id={pdf ? "myPage3" : null}>
                {restrictions["diabetes"].min_age <= Age && restrictions["diabetes"].max_age >= Age && Diabetes && !DiabetesPresent ?
                <div className='UserProfileHealthReportWhiteBlock2 UserProfileHealthReportUpperBlockRightSide' style={{width:"100%"}}>
                    {pdf ?
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex'>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBIndicatorIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Riesgo de Diabetes</div>
                    </div>
                    :
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex' style={{cursor:"pointer"}} onClick={() => toggleSummary(3)}>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBIndicatorIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Riesgo de Diabetes</div>
                        <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonIconFlex'>
                            <img alt="Down Arrow" id="Arrow3" className='UserProfileInnerDivCalculatorWhiteBlockDoneBlockIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleDownArrowIcon.png" />
                        </div>
                    </div>
                    }
                    <div className={pdf ? 'UserProfileHealthReportHideableBlock' : 'UserProfileHealthReportHideableBlock UserProfileInnerDivCalculatorWhiteBlockSummaryHidden'} id="Hide3">
                        <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{color: Diabetes.risk > 2 ? "white" : null ,backgroundColor: Diabetes.risk < 2 ? "#8BC53F" : Diabetes.risk === 2 ? "#FFCD29" : "#FF4F53"}}>
                            <h5 className='UserProfileHealthReportHabitsLeftUpBlockText'>Riesgo {Diabetes.riskCat}</h5>
                            <div className="UserProfileHealthReportGeneralText">de padecer diabetes tipo 2 a 10 años</div>
                        </div>
                        <div className='UserProfileHealthReportHabitsLeftFlex'>
                            <div className='UserProfileHealthReportHabitsLeftSideBlock' style={{ backgroundColor: Diabetes.risk < 2 ? "rgba(139, 197, 63, .47)" : Diabetes.risk === 2 ? "rgba(255, 205, 41, .5)" : "rgba(255, 79, 83, .47)", color: Diabetes.risk > 2 ? "white": ""}}>
                                <img alt="" className='UserProfileHealthReportHabitsLeftSideBlockImage' src={DiabetesImage} />
                            </div>
                            <div className='UserProfileHealthReportHabitsLeftSideBlock2' style={{ backgroundColor: Diabetes.risk < 2 ? "rgba(139, 197, 63, 1)" : Diabetes.risk === 2 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: Diabetes.risk > 2 ? "white": ""}}>
                                {Diabetes.risk < 2 ?
                                <div className="UserProfileHealthReportGeneralText">¿Sabías que el riesgo cambia con el tiempo y aumenta con la edad?<br/><br/>Mantén el control de tu salud.</div>
                                : Diabetes.risk === 2 ?
                                <>
                                    <div className="UserProfileHealthReportGeneralText">Cada 100 personas con el mismo riesgo,</div>
                                    <h4 className="UserProfileHealthReportHabitsLeftSideBlockText">17 personas</h4>
                                    <div className="UserProfileHealthReportGeneralText">desarrollarán diabetes en un plazo de 10 años.</div>
                                </>
                                :
                                <>
                                    <div className="UserProfileHealthReportGeneralText">Cada 100 personas con el mismo riesgo,</div>
                                    <h4 className="UserProfileHealthReportHabitsLeftSideBlockText">{Diabetes.points < 20 ? 33 : 50} personas</h4>
                                    <div className="UserProfileHealthReportGeneralText">desarrollarán diabetes en un plazo de 10 años.</div>
                                </>
                                }
                            </div>
                        </div>
                        <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url("+MeterSimple+")",backgroundPosition: 'left',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                            <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src={Diabetes.risk < 2 ? FaceLowRisk : Diabetes.risk === 2 ? FaceMidRisk : FaceHighRisk} style={ Diabetes.risk < 2 ? { left: "0%" } : Diabetes.risk === 2 ? { left: "-3px", right: "0", margin: "0 auto" } : { right: "-5px" } } />
                        </div>
                        <div className="UserProfileHealthReportGeneralText" style={{marginBlockStart:"10px", color:"#330066"}}>Hoy 2,5 millones de chilenos sufren esta patología.
                            <br/><br/>Estudios nacionales han reportado que más de la mitad de los pacientes diabéticos son muchas veces diagnosticados tarde, es decir, cuando ya presentaban síntomas de que la enfermedad se había desarrollado. Asegúrate de realizar tus exámenes preventivos regularmente y mantener hábitos de vida saludables para prevenir o retrasar el desarrollo de enfermedades como la diabetes y la enfermedad renal crónica.</div>
                    </div>
                </div>
                : null}

                {Sleep && restrictions["sleep_apnea"].min_age <= Age && restrictions["sleep_apnea"].max_age >= Age ?
                <div className='UserProfileHealthReportWhiteBlock2 UserProfileHealthReportUpperBlockRightSide' style={{width:"100%"}}>
                    {pdf ? 
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex'>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBBedIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Riesgo de Apnea de Sueño</div>
                    </div>
                    :
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex' style={{cursor:"pointer"}} onClick={() => toggleSummary(4)}>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBBedIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Riesgo de Apnea de Sueño</div>
                        <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonIconFlex'>
                            <img alt="Down Arrow" id="Arrow4" className='UserProfileInnerDivCalculatorWhiteBlockDoneBlockIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleDownArrowIcon.png" />
                        </div>
                    </div>
                    }
                    <div className={pdf ? 'UserProfileHealthReportHideableBlock' : 'UserProfileHealthReportHideableBlock UserProfileInnerDivCalculatorWhiteBlockSummaryHidden'} id="Hide4">
                        <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{color: Sleep.risk === 2 ? "white" : null ,backgroundColor: Sleep.risk === 0 ? "#8BC53F" : Sleep.risk === 1 ? "#FFCD29" : "#FF4F53"}}>
                            <h5 className='UserProfileHealthReportHabitsLeftUpBlockText'>Riesgo {Sleep.risk_cat}</h5>
                            <div className="UserProfileHealthReportGeneralText">síndrome de apnea obstructiva del sueño</div>
                        </div>
                        <div className='UserProfileHealthReportHabitsLeftSideBlock' style={{ width:"100%", backgroundColor: Sleep.risk === 0 ? "rgba(139, 197, 63, .47)" : Sleep.risk === 1 ? "rgba(255, 205, 41, .5)" : "rgba(255, 79, 83, .47)", color: Sleep.risk === 2 ? "white": ""}}>
                            <img alt="" className='UserProfileHealthReportHabitsLeftSideBlockImage' src={SleepImage} />
                        </div>
                        <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url("+MeterSimple+")",backgroundPosition: 'left',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                            <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src={Sleep.risk === 0 ? FaceLowRisk : Sleep.risk === 1 ? FaceMidRisk : FaceHighRisk} style={ Sleep.risk === 0 ? { left: "0%" } : Sleep.risk === 1 ? { left: "-3px", right: "0", margin: "0 auto" } : { right: "-5px" } } />
                        </div>
                        <div className="UserProfileHealthReportGeneralText" style={{marginBlockStart:"10px", color:"#330066"}}>La apnea obstructiva del sueño es un trastorno en el que la respiración se interrumpe repetidamente durante el sueño, lo que puede afectar tu salud, energía diaria y calidad de vida.
                            <br/>Si roncas, te despiertas cansado o sientes somnolencia durante el día, podrías estar en riesgo.
                            <br/>Evaluar y gestionar este riesgo es clave para prevenir complicaciones y mejorar tu bienestar.</div>
                        <h5 className='UserWelcomeBlockResultsCategoriesTitle' style={{fontWeight:"500", letterSpacing:"1px",marginBlockStart:"10px"}}>Para vivir mejor hay que dormir mejor, roncar no es normal.</h5>
                        { Sleep.risk === 0 ?
                            <div className='UserWelcomeBlockResultsCategoriesTitle2'>Usted posee un riesgo BAJO de síndrome de apnea obstructiva del sueño, te recomendamos estar atento a los síntomas.</div>
                        : Sleep.risk === 1 ?
                        <>
                            <div className='UserWelcomeBlockResultsCategoriesTitle2'>Usted posee un Riesgo MEDIO de síndrome de apnea obstructiva del sueño, te recomendamos profundizar los estudios agendando un examen de poligrafía cardiorrespiratoria de sueño en tu centro de salud de preferencia.</div>
                            {pdf ? null :
                            <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/packs-de-examenes/detalles-de-pack?pack=PM00YMC043");}}>Conseguir Orden Médica</div>
                            }
                        </>
                        :
                        <>
                            <div className='UserWelcomeBlockResultsCategoriesTitle2'>Usted posee un Riesgo ALTO de síndrome de apnea obstructiva del sueño, te recomendamos profundizar los estudios agendando un examen de poligrafía cardiorrespiratoria de sueño en tu centro de salud de preferencia.</div>
                            {pdf ? null :
                            <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/packs-de-examenes/detalles-de-pack?pack=PM00YMC043");}}>Conseguir Orden Médica</div>
                            }
                        </>
                        }
                    </div>
                </div>
                : 
                null}

                {restrictions["met_syndrome"].min_age <= Age && restrictions["met_syndrome"].max_age >= Age && Metabolic ?
                <div className='UserProfileHealthReportWhiteBlock2 UserProfileHealthReportUpperBlockRightSide' style={{width:"100%"}}>
                    {pdf ? 
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex'>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBCardiacProblemIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Riesgo de Síndrome Metabólico</div>
                    </div>
                    :
                    <div className='UserProfileHealthReportUpperBlockRightSideSectionTitleFlex' style={{cursor:"pointer"}} onClick={() => toggleSummary(5)}>
                        <img  alt="" className='UserProfileHealthReportUpperBlockRightSideSectionTitleIcon' src={SBCardiacProblemIcon}/>
                        <div className='UserProfileHealthReportUpperBlockRightSideSectionTitle'>Riesgo de Síndrome Metabólico</div>
                        <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonIconFlex'>
                            <img alt="Down Arrow" id="Arrow5" className='UserProfileInnerDivCalculatorWhiteBlockDoneBlockIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleDownArrowIcon.png" />
                        </div>
                    </div>
                    }
                    <div className={pdf ? 'UserProfileHealthReportHideableBlock' : 'UserProfileHealthReportHideableBlock UserProfileInnerDivCalculatorWhiteBlockSummaryHidden'} id="Hide5">
                        <div className='UserProfileHealthReportHabitsLeftUpBlock' style={{color: Metabolic.risk === 2 ? "white" : null ,backgroundColor: Metabolic.risk === 0 ? "#8BC53F" : Metabolic.risk === 1 ? "#FFCD29" : "#FF4F53"}}>
                            <h5 className='UserProfileHealthReportHabitsLeftUpBlockText'>{Metabolic.riskCat}</h5>
                        </div>
                        <div className='UserProfileHealthReportHabitsLeftSideBlock' style={{ width:"100%", backgroundColor: Metabolic.risk === 0 ? "rgba(139, 197, 63, .47)" : Metabolic.risk === 1 ? "rgba(255, 205, 41, .5)" : "rgba(255, 79, 83, .47)", color: Metabolic.risk === 2 ? "white": ""}}>
                            <img alt="" className='UserProfileHealthReportHabitsLeftSideBlockImage' src={MetabolicImage} />
                        </div>
                        <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url("+MeterSimple+")",backgroundPosition: 'left',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                            <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src={Metabolic.risk === 0 ? FaceLowRisk : Metabolic.risk === 1 ? FaceMidRisk: FaceHighRisk} style={ Metabolic.risk === 0 ? { left: "0%" } : Metabolic.risk === 1 ? { left: "-3px", right: "0", margin: "0 auto" } : { right: "-5px" } } />
                        </div>
                        {Metabolic.risk === 0 ?
                            <div className="UserProfileHealthReportGeneralText" style={{marginBlockStart:"10px", color:"#330066"}}>Con base en los antecedentes brindados, no cumple con los criterios diagnósticos de síndrome metabólico según los parámetros establecidos por el Ministerio de Salud (MINSAL) y organismos internacionales como la American Heart Association. Aunque los factores de riesgo no están presentes o se encuentran dentro de los límites normales, es importante mantener un estilo de vida saludable para prevenir la aparición de alteraciones metabólicas en el futuro ya que esta enfermedad aumenta con la edad.</div>
                        : Metabolic.risk === 1 ?
                            <div className="UserProfileHealthReportGeneralText" style={{marginBlockStart:"10px", color:"#330066"}}>Con base en los antecedentes brindados, presenta alteraciones metabólicas que, aunque no cumplen con los criterios diagnósticos de síndrome metabólico, sugieren un riesgo aumentado de desarrollarlo en el futuro. Esta etapa representa una oportunidad para intervenir de manera efectiva y prevenir complicaciones mayores.</div>
                        : 
                            <div className="UserProfileHealthReportGeneralText" style={{marginBlockStart:"10px", color:"#330066"}}>Con base en los antecedentes brindados, cumple con los criterios diagnósticos de síndrome metabólico establecidos por el Ministerio de Salud (MINSAL) y organismos internacionales como la American Heart Association, lo que implica un riesgo significativamente mayor de desarrollar enfermedades cardiovasculares y diabetes tipo 2. Este diagnóstico requiere un manejo integral y seguimiento médico continuo para reducir el impacto en la salud.</div>
                        }
                        <div className='UserWelcomeBlockResultsCategoriesTitle2'>Es importante mantener un estilo de vida saludable para prevenir la aparición de alteraciones metabólicas en el futuro ya que esta enfermedad aumenta con la edad.</div>
                    </div>
                </div>
                : null}
            </div>
        </div>
        );
      }

    return (
        <div className='UserProfileFull2'>
            <div className='UserProfileInnerDiv UserProfileHealthReportInnerPreDiv'>
                <h3 className='UserProfileHealthReportTitle' style={{marginBlock:"10px"}}>Informe de Salud</h3>
                {TaskDone ?
                <div className='GeneralPurpleButtonFlex ' style={{width:"fit-content"}} onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0;  setOpenModal(true)}}>
                    <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockRightButtonText'>Descargar PDF</div>
                    <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/WhiteMedicalDataIcon.svg" />
                </div>
                : null}
            </div>
            {TaskDone ?
            <Report pdf={false} />
            : null}
            <Modal dismissible show={openModal} position="center" className='OrderDownloadPreviewModal'>
                <Modal.Body className='OrderDownloadPreviewModalBody'>
                    <div className='OrderDownloadPreviewModalHeaderTitle'>Preview Informe de Salud</div>
                    <div className='OrderDownloadPreviewModalHeaderButtons'>
                        <div className="GeneralPurpleButtonFlex OrderDownloadPreviewModalDownloadButton" onClick={() => PDFstuff()}>DESCARGAR</div>
                        <div className="GeneralPurpleButtonFlex OrderDownloadPreviewModalCloseButton" onClick={() => setOpenModal(false)}>CERRAR</div>
                    </div>
                    <div className='UserProfileHealthReportPDFContainer'>
                    <Report pdf={true} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <div className="OrderDownloadPreviewModalFooter">
                    <div className="GeneralPurpleButtonFlex OrderDownloadPreviewModalFooterCloseButton" onClick={() => setOpenModal(false)}>CERRAR</div>
                </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default UserProfileHealthReport;